'use client';

import { Box, Button, Typography } from '@mui/material';

import { PALETTE_KEYS } from '@/constants/theme.constants';

interface InvalidLinkViewProps {
  allParams: Record<string, string>;
  onBack: () => void;
}

export const InvalidLinkView = ({ allParams, onBack }: InvalidLinkViewProps) => {
  const renderParamItem = ([key, value]: [string, string]) => (
    <Typography
      key={key}
      variant="caption"
      sx={{ display: 'block', fontFamily: 'monospace', color: PALETTE_KEYS.SUCCESS_MAIN }}
    >
      {key}: {value}
    </Typography>
  );

  const renderedParamsList = Object.entries(allParams).map(renderParamItem);

  return (
    <Box sx={{ py: 10, textAlign: 'center', px: 2 }}>
      <Typography variant="h5" color={PALETTE_KEYS.ERROR_MAIN} gutterBottom>
        Invalid Withdrawal Link
      </Typography>
      <Typography variant="body2" color={PALETTE_KEYS.TEXT_SECONDARY} sx={{ mb: 4 }}>
        Please ensure your URL contains `?withdrawalId=numeric_id`.
      </Typography>

      {Object.keys(allParams).length > 0 && (
        <Box
          sx={{
            mt: 2,
            mb: 4,
            p: 2,
            bgcolor: 'action.hover',
            borderRadius: 2,
            textAlign: 'left',
            display: 'inline-block',
          }}
        >
          <Typography
            variant="caption"
            color={PALETTE_KEYS.TEXT_SECONDARY}
            sx={{ display: 'block', mb: 1 }}
          >
            Received Parameters:
          </Typography>
          {renderedParamsList}
        </Box>
      )}

      <Box>
        <Button variant="contained" onClick={onBack} sx={{ bgcolor: 'primary.main' }}>
          Go to Portfolio
        </Button>
      </Box>
    </Box>
  );
};
